import {
    Component, OnInit, ViewChild, AfterViewInit, OnDestroy
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CumplimientoMetasService } from 'src/app/services/cumplimiento-metas.service';
import { AuthService } from "src/app/services/auth.service";
import { CustomResponseObject } from 'src/app/model/promotion-models';
import { CatComponentService } from 'src/app/services/cat-component.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-cumplimiento-metas',
    templateUrl: './cumplimiento-metas.component.html',
    styleUrls: ['./cumplimiento-metas.component.css']
})
export class CumplimientoMetasComponent implements OnInit, AfterViewInit, OnDestroy {

    public viewStatus: number = 0;

    public displayedColumns: string[] = [
        'id', 'asesorId', 'nombrePromocion', 'montoLogrado', 'comisionAPagar',
        'fechaLogro', 'retroactivoAplicado', 'fechaRetroactivoAplicado', 'pagoAutorizado'
        , 'fechaAutorizacion', 'acciones'
    ];

    public dataSource = new MatTableDataSource<any>([]);

    @ViewChild(MatSort, { static: false }) sort: MatSort;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    private destroy$ = new Subject<void>();

    private botonCalcularMetas: boolean = false;
    private botonAutorizarMetas: boolean = false;

    // ── Propiedades para el detalle ──────────────────────────────
    public detalleDataSource = new MatTableDataSource<any>([]);
    public mostrarDetalle: boolean = false;
    public elementoSeleccionado: any = null;

    //Propiedades de busqueda de la tabla.
    filterValue: string = '';
    searchField: string = 'asesor';

    public detalleColumns: string[] = [
        'detalleRetroactivoId', 'creditId', 'nombrePromocion',
        'fechaCobro', 'comisionOriginal', 'comisionMeta',
        'delta', 'montoCapitalTotal', 'comisionAPagar', 'fechaAplicado'
    ];

    @ViewChild('detalleSort', { static: false }) detalleSort: MatSort;
    @ViewChild('detallePaginator', { static: false }) detallePaginator: MatPaginator;

    // ← Solo un parámetro en el constructor
    constructor(private cumplimientoMetasService: CumplimientoMetasService,
        private catComponentService: CatComponentService,
        private auth: AuthService) { }

    ngOnInit(): void {
        this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
            elementGrant.data.filter(el => el.component === "app-comisiones-simulador" && this.auth.getUserRoles().includes(el.role))
                .map(el => {
                    if ("boton-calculo-metas" === el.description) {
                        this.botonCalcularMetas = el.active;
                    }
                    if ("boton-autorizar-metas" === el.description) {
                        this.botonAutorizarMetas = el.active;
                    }
                });
        });
        this.cargarDatos();
    }

    ngAfterViewInit(): void {
        this.setupCustomFilter();
        setTimeout(() => {
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onSearchFieldChange(): void {
        // ← Limpiar filtro al cambiar de tipo
        this.filterValue = '';
        this.dataSource.filter = '';
        this.dataSource.filterPredicate = this.buildFilterPredicate();
    }

    setupCustomFilter() {
        this.dataSource.filterPredicate = (data: any, filter: string) => {
            const searchStr = filter.trim().toLowerCase();
            if (this.searchField === 'asesor') {
                return data.idAsesor.toLowerCase().includes(searchStr);
            } else if (this.searchField === 'promocion') {
                return data.nombrePromocion.toLowerCase().includes(searchStr);
            } else if (this.searchField === 'fechaLogro') {
                return data.fechaLogro.toLowerCase().includes(searchStr);
            } else if (this.searchField === 'autorizado') {
                return data.pagoAutorizado.toString().includes(searchStr);
            }
            return false;
        };
    }

    cargarDatos(): void {
        this.filterValue = '';
        this.viewStatus = 0;
        this.cumplimientoMetasService.obtenerTodos()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data: CustomResponseObject<any>) => {
                    console.log('Metas cumplidas obtenidas:', data);
                    this.dataSource.data = data.data || [];
                    // setTimeout reemplaza el markForCheck()
                    this.viewStatus = 1;

                    setTimeout(() => {
                        // this.viewStatus = 1;
                        if (this.paginator) this.dataSource.paginator = this.paginator;
                        if (this.sort) this.dataSource.sort = this.sort;
                    }, 0);
                },
                error: (err) => {
                    console.error('Error al cargar metas cumplidas:', err);
                    this.viewStatus = 1;
                }
            });
    }

    applyFilter(event: Event): void {
        const value = (event.target as HTMLInputElement).value.toLowerCase();
        // const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.filterValue = value;
        this.dataSource.filter = value;
        if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
    }

    applyFilterByField(): void {
        // ← Para fecha y selector que no usan keyup
        this.dataSource.filterPredicate = this.buildFilterPredicate();
        this.dataSource.filter = this.filterValue.trim().toLowerCase() || '';
        if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
    }

    buildFilterPredicate(): (data: any, filter: string) => boolean {
        return (data: any, filter: string): boolean => {
            if (!filter) return true;

            switch (this.searchField) {
                case 'asesor':
                    return (data.idAsesor || '').toLowerCase().includes(filter);

                case 'promocion':
                    return (data.promocionId.toString() || '').includes(filter) ||
                        (data.nombrePromocion || '').toLowerCase().includes(filter);

                case 'fechaLogro':
                    if (!data.fechaLogro) return false;
                    // ← Convertir la fecha del registro a yyyy-MM-dd en zona local
                    // sin usar toISOString() que convierte a UTC y puede cambiar el día
                    const fechaRegistro = new Date(data.fechaLogro);
                    const anio = fechaRegistro.getFullYear();
                    const mes = String(fechaRegistro.getMonth() + 1).padStart(2, '0');
                    const dia = String(fechaRegistro.getDate()).padStart(2, '0');
                    const fechaNormalizada = `${anio}-${mes}-${dia}`;

                    // ← filter ya viene en formato yyyy-MM-dd desde el input date
                    return fechaNormalizada === filter;

                case 'autorizado':
                    if (filter === '') return true;
                    const autorizado = filter === 'true';
                    return data.pagoAutorizado === autorizado;

                default:
                    return true;
            }
        };
    }

    formatearFecha(fecha: any): string {
        if (!fecha) return '—';
        return new Date(fecha).toLocaleString('es-MX');
    }

    formatearMonto(monto: any): string {
        if (monto === null || monto === undefined) return '—';
        return new Intl.NumberFormat('es-MX', {
            style: 'currency', currency: 'MXN'
        }).format(monto);
    }

    toggleAutorizarPago(element: any, accion: string): void {
        Swal.fire({
            title: `¿${accion} pago?`,
            html: `¿Confirmas que deseas ${accion.toLowerCase()} el pago para el asesor <strong>${element.idAsesor}</strong>?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, autorizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (!result.isConfirmed) return; // ← canceló → no hacer nada

            // ← Mostrar spinner mientras se procesa
            Swal.fire({
                title: 'Procesando...',
                html: ` ${accion === 'Autorizar' ? 'Autorizando' : 'Revertiendo'} pago, por favor espere.`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => Swal.showLoading()
            });

            this.cumplimientoMetasService.autorizarPago(element.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (resp: CustomResponseObject<any>) => {
                        let icon = 'success';
                        let title = `¡${accion} pago!`;
                        let errorMsg = `El ${accion === 'Autorizar' ? 'pago' : 'autorización'} del asesor ${element.idAsesor} fue ${accion === 'Autorizar' ? 'autorizado' : 'revertido'} correctamente.`;
                        if (resp.httpStatusCode !== 200) {
                            icon = 'error';
                            title = 'Error al ' + accion.toLowerCase();
                            errorMsg = resp.messageError;
                        }

                        Swal.fire({
                            icon: icon as any,
                            title: title,
                            text: errorMsg,
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#28a745'
                        });
                        this.cargarDatos();
                    },
                    error: (err) => {
                        console.error(`Error al ${accion === 'Autorizar' ? 'autorizar' : 'revertir'} pago:`, err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: `Ocurrió un problema al ${accion === 'Autorizar' ? 'autorizar' : 'revertir'} el pago. Intenta de nuevo.`,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                });
        });
    }

    consultarRetroactivo(element: any) {
        this.elementoSeleccionado = element;
        this.mostrarDetalle = false;

        Swal.fire({
            title: 'Cargando detalle...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading()
        });

        this.cumplimientoMetasService.obtenerDetalle(element.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (resp: CustomResponseObject<any>) => {
                    Swal.close();
                    if (!resp.data || resp.data.length === 0) {
                        Swal.fire({
                            icon: 'info',
                            title: `¡Sin detalle!`,
                            text: `No hay información disponible para el registro seleccionado.`,
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#28a745'

                        });
                        this.mostrarDetalle = false;
                    } else {
                        this.detalleDataSource.data = resp.data || [];
                        this.mostrarDetalle = true;

                    }
                    setTimeout(() => {
                        if (this.detalleSort) this.detalleDataSource.sort = this.detalleSort;
                        if (this.detallePaginator) this.detalleDataSource.paginator = this.detallePaginator;
                    }, 0);
                },
                error: (err) => {
                    console.error('Error al cargar detalle:', err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo cargar el detalle.',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
    }

    eliminarRegistro(element: any): void {
        Swal.fire({
            title: `¿Eliminar meta pago?`,
            html: `¿Confirmas que deseas eliminar el pago para el asesor <strong>${element.idAsesor}</strong>?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (!result.isConfirmed) return; // ← canceló → no hacer nada

            this.cumplimientoMetasService.eliminarMetaCumplida(element.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (resp: CustomResponseObject<any>) => {
                        let icon = 'success';
                        let title = '¡Registro eliminado!';
                        let errorMsg = `El registro del asesor ${element.idAsesor} fue eliminado correctamente.`;
                        if (resp.httpStatusCode !== 200) {
                            icon = 'error';
                            title = 'Error al eliminar';
                            errorMsg = resp.messageError;
                        }
                        Swal.fire({
                            icon: icon as any,
                            title: title,
                            text: errorMsg,
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: '#28a745'
                        });
                        this.cargarDatos();
                    },
                    error: (err) => {
                        console.error(`Error al eliminar registro:`, err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: `Ocurrió un problema al eliminar el registro. Intenta de nuevo.`,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                });
        });
    }

    calcularMetas() {
        // ← PASO 1: Swal de confirmación antes de ejecutar
        Swal.fire({
            title: '¿Calcular cumplimiento de metas?',
            html: `
            <div style="text-align: left; font-size: 14px; line-height: 1.8;">
                <p>Este proceso realizará las siguientes acciones:</p>
                <ul style="padding-left: 20px;">
                    <li>Evaluará el cumplimiento de metas de todos los asesores</li>
                    <li>Generará los retroactivos correspondientes</li>
                    <li>Solo se calcularán las metas que hayan concluido su periodo</li>
                </ul>
                <div style="background-color: #fff3cd; border-left: 4px solid #ffc107;
                            padding: 10px 14px; border-radius: 4px;">
                    <strong>⚠️ Importante:</strong> Este proceso puede tardar varios minutos.
                    Asegúrate de ejecutarlo en el momento adecuado.
                </div>
            </div>
        `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '<i class="icon-flag"></i>&nbsp; Sí, calcular ahora',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: '520px',
        }).then((result) => {
            if (!result.isConfirmed) return; // ← canceló → no hacer nada

            // ← Mostrar Swal con spinner bloqueando la pantalla
            Swal.fire({
                title: 'Calculando metas...',
                html: 'Por favor espere, este proceso podría tardar un momento.',
                allowOutsideClick: false,   // ← no cerrar al hacer click fuera
                allowEscapeKey: false,      // ← no cerrar con ESC
                showConfirmButton: false,   // ← ocultar botón de confirmar
                didOpen: () => {
                    Swal.showLoading();     // ← activar spinner
                }
            });

            this.cumplimientoMetasService.ejecutarCalculoMetas().subscribe({
                next: (resp: any) => {
                    Swal.close(); // ← cerrar spinner
                    if (resp && resp.httpStatusCode === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: '¡Cálculo completado!',
                            text: 'El cálculo de cumplimiento de metas se ejecutó exitosamente.',
                            confirmButtonText: 'Aceptar'
                        });
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Respuesta inesperada',
                            text: resp.messageError || 'El servicio respondió con un estado no esperado.',
                            confirmButtonText: 'Aceptar'
                        });
                    }
                },
                error: (error: any) => {
                    console.error('Error al calcular cumplimiento de metas:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Ha ocurrido un problema al intentar calcular el cumplimiento de metas.',
                        confirmButtonText: 'Aceptar'
                    });
                }
            });
        });
    }

    autorizarTodo(): void {
        // ← Obtener registros según si hay filtro activo o no
        const registros: any[] = this.dataSource.filteredData.length > 0 &&
            this.dataSource.filter
            ? this.dataSource.filteredData  // ← hay filtro → solo los filtrados
            : this.dataSource.data;         // ← sin filtro → todos

        // ← Excluir los que ya están autorizados
        const pendientes = registros.filter(r => !r.pagoAutorizado);

        if (pendientes.length === 0) {
            Swal.fire({
                icon: 'info',
                title: 'Sin pendientes',
                text: 'Todos los registros mostrados ya están autorizados.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        const hayFiltro = !!this.dataSource.filter;

        // ← Swal de confirmación
        Swal.fire({
            title: '¿Autorizar pagos?',
            html: `
            <div style="text-align: left; font-size: 14px; line-height: 1.8;">
                <p>Se autorizarán <strong>${pendientes.length}</strong> registro(s)
                ${hayFiltro ? 'que coinciden con el filtro actual' : 'en total'}.
                </p>
                <div style="background-color: #fff3cd; border-left: 4px solid #ffc107;
                            padding: 10px 14px; border-radius: 4px; margin-top: 8px;">
                    <strong>⚠️ Esta acción no se puede deshacer fácilmente.</strong><br>
                    Asegúrate de que los registros sean correctos antes de continuar.
                </div>
            </div>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: '<i class="icon-ok"></i>&nbsp; Sí, autorizar todo',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#17a2b8',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: '480px'
        }).then((result) => {
            if (!result.isConfirmed) return;

            // ← Spinner mientras se procesan
            Swal.fire({
                title: 'Autorizando pagos...',
                html: `Procesando <strong>${pendientes.length}</strong> registro(s), por favor espere.`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => Swal.showLoading()
            });

            // ← Extraer solo los IDs a autorizar
            const ids: number[] = pendientes.map((r: any) => r.id);

            this.cumplimientoMetasService.autorizarTodo(ids)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (resp: any) => {
                        Swal.close();
                        if (resp && resp.httpStatusCode === 200) {
                            Swal.fire({
                                icon: 'success',
                                title: '¡Pagos autorizados!',
                                text: `Se autorizaron ${resp.data} registro(s) correctamente.`,
                                confirmButtonText: 'Aceptar',
                                confirmButtonColor: '#28a745'
                            }).then(() => this.cargarDatos());
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Respuesta inesperada',
                                text: resp.messageError || 'El servicio respondió con un estado no esperado.',
                                confirmButtonText: 'Aceptar'
                            });
                        }
                    },
                    error: (err: any) => {
                        console.error('Error al autorizar todo:', err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrió un problema al autorizar los pagos. Intenta de nuevo.',
                            confirmButtonText: 'Aceptar'
                        });
                    }
                });
        });
    }

    cerrarDetalle(): void {
        this.mostrarDetalle = false;
        this.elementoSeleccionado = null;
        this.detalleDataSource.data = [];
    }
}